<div class="right-menu-panel">
  <app-layers-menu [activeMenuGroup]="activeMenuGroup"></app-layers-menu>

  <button app-icon-button iconSize="16px" class="layers-menu-close-button" *ngIf="(breakpointObserverService.isMobile | async) && menuService.isMenuOpened" (click)="emitCloseMenuMobile()">
    <app-icon svgIcon="dropdownArrow"></app-icon>
  </button>
</div>
